import { ProjectOverViewTable } from "../Components/ProjectOverViewTable";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";

interface ProjectOverviewProps {
  prGroupId?: string;
}

export const ProjectOverview = ({ prGroupId }: ProjectOverviewProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="g-card">
      <ProjectOverViewTable
        prGroupId={prGroupId}
        goToNewProject={() => navigate(`new`)}
        preservedSearchQuery={(location.state as { searchQuery?: string })?.searchQuery}
      />
    </div>
  );
};
